import React from 'react';
import PropTypes from 'prop-types';
import { P } from 'sushiweb/Typography/Text';
import H6 from 'sushiweb/Typography/Heading/H6';
import Tooltip from 'sushiweb/Tooltip/Tooltip';
import Shimmer from 'sushiweb/Shimmer/Shimmer';
import {
  DetailsContainer,
  DetailsContainerForInvoice,
  DiscountedAmountWrapper,
  DiscountedPercentContainer,
  DiscountedPercentWrapper,
  DiscountWrapper,
} from './styles';
import {
  DiscountIcon,
  InfoLineIcon,
} from '../../../../components/SVGs/commonSVGs';

const DetailsWrapper = ({
  tooltipDirection,
  showInfoTip,
  tooltipMessage,
  label,
  value,
  subValue,
  showDiscount,
  discount,
  loading,
  forInvoice,
}) => {
  const getDetailsWrapper = () => {
    if (forInvoice) {
      return (
        <DetailsContainerForInvoice text={value} showDiscount={showDiscount}>
          <P>{label}</P>
          {showDiscount && (
            <DiscountWrapper>
              {' '}
              <DiscountedAmountWrapper>
                {' '}
                {subValue}
              </DiscountedAmountWrapper>
              {' '}
              <DiscountedPercentWrapper>
                {' '}
                <DiscountIcon />
                {' '}
                <DiscountedPercentContainer>
                  {' '}
                  {`${discount}%OFF`}
                  {' '}
                </DiscountedPercentContainer>
              </DiscountedPercentWrapper>
              {' '}
            </DiscountWrapper>
          )}
          <H6>{value}</H6>
        </DetailsContainerForInvoice>
      );
    }
    return (
      <DetailsContainer text={value}>
        <>
          <P>
            {label}
            {showInfoTip && (
              <Tooltip
                position={tooltipDirection}
                showTooltip={showInfoTip}
                label={tooltipMessage}
                className='tooltipInfo'
                appearance='light'
                size='small'
                style={{
                  marginLeft: '-180px',
                  fontSize: '12px',
                  padding: '5px',
                  borderRadius: '10px',
                  opacity: '0.8',
                  width: '200px',
                }}
              >
                <InfoLineIcon />
              </Tooltip>
            )}
          </P>
          <H6>
            {value} 
            {' '}
            {subValue && <span>{subValue}</span>}
            {' '}
          </H6>
        </>
      </DetailsContainer>
    );
  };
  return loading ? (
    <Shimmer
      width='100%'
      height='124px'
      style={{
        borderRadius: '20px',
        backgroundColor: 'var(--coolgreycoolgrey-100, #f2f4f7)',
      }}
    />
  ) : (
    getDetailsWrapper()
  );
};

DetailsWrapper.propTypes = {
  tooltipDirection: PropTypes.string,
  showInfoTip: PropTypes.bool,
  tooltipMessage: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  subValue: PropTypes.string,
  loading: PropTypes.bool,
  forInvoice: PropTypes.bool,
  showDiscount: PropTypes.bool,
  discount: PropTypes.string,
};

DetailsWrapper.defaultProps = {
  tooltipDirection: 'top',
  showInfoTip: false,
  tooltipMessage: '',
  label: '',
  value: '',
  subValue: '',
  loading: false,
  forInvoice: false,
  showDiscount: false,
  discount: '',
};

export default DetailsWrapper;
